import { cn } from "@/lib/utils";
import "./loader.css";

type Variant = "rect" | "triangle" | "circle";

export function Loader({ variant = "rect", className }: { variant?: Variant; className?: string }) {
  return (
    <div className={cn("loader", variant === "triangle" && "triangle", className)} aria-label="Loading">
      <svg viewBox="0 0 80 80">
        {variant === "rect" && <rect x="8" y="8" width="64" height="64" />}
        {variant === "triangle" && <polygon points="40,8 72,72 8,72" />}
        {variant === "circle" && <circle cx="40" cy="40" r="32" />}
      </svg>
    </div>
  );
}

export function FullPageLoader({ label }: { label?: string }) {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-background">
      <div className="flex items-center gap-2">
        <Loader variant="rect" />
        <Loader variant="triangle" />
        <Loader variant="circle" />
      </div>
      {label && <div className="text-xs text-muted-foreground">{label}</div>}
    </div>
  );
}
